import newFolderComponent from './modal/NewFolderModalComponent'
import RenameItemComponent from './modal/RenameItemModalComponent'

export const NewFolderModal = newFolderComponent
export const RenameItemModal = RenameItemComponent
